export default "__VITE_ASSET__BT40VqlQ__"